import { render, staticRenderFns } from "./region_list.vue?vue&type=template&id=722ba73c&scoped=true"
import script from "./region_list.vue?vue&type=script&lang=js"
export * from "./region_list.vue?vue&type=script&lang=js"
import style0 from "./region_list.vue?vue&type=style&index=0&id=722ba73c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722ba73c",
  null
  
)

export default component.exports